/**
 * Konvensi penyimpanan sub lokasi:
 * - Data baru: array string nama → ["Area A", "Area B"]
 * - Data lama: string tunggal → "Area A" (bisa mengandung koma di nama)
 *
 * Jangan split string legacy dengan koma — nama dari service bisa memuat ",".
 */

/** Normalisasi dari form UI / berbagai bentuk ke array nama (simpan ke API). */
export function normalizeSubLokasiToNames(subLokasi) {
  return parseSubLokasiFromApi(subLokasi);
}

/**
 * Baca nilai dari API/DB ke array nama untuk dipakai di form atau logika app.
 */
export function parseSubLokasiFromApi(value) {
  if (value == null || value === "") return [];

  if (Array.isArray(value)) {
    return value
      .map((item) =>
        typeof item === "string" ? item.trim() : item?.name?.trim(),
      )
      .filter(Boolean);
  }

  if (typeof value === "object" && value.name) {
    return [String(value.name).trim()].filter(Boolean);
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return [];

    // Opsional: backend simpan JSON array di kolom text
    if (trimmed.startsWith("[")) {
      try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed)) {
          return parsed
            .map((item) =>
              typeof item === "string" ? item.trim() : item?.name?.trim(),
            )
            .filter(Boolean);
        }
      } catch {
        // Bukan JSON valid → anggap legacy plain text
      }
    }

    // Legacy: satu string = satu sub lokasi (meski ada koma di nama)
    return [trimmed];
  }

  return [];
}

/** true = data lama (string / object tunggal), false = data baru (array). */
export function isSubLokasiLegacyFormat(value) {
  if (value == null || value === "") return true;
  if (Array.isArray(value)) return false;

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return true;
    if (trimmed.startsWith("[")) {
      try {
        return !Array.isArray(JSON.parse(trimmed));
      } catch {
        return true;
      }
    }
    return true;
  }

  if (typeof value === "object") return true;

  return true;
}

/** Tampilan di preview/table — aman untuk legacy & baru. */
export function formatSubLokasiDisplay(value) {
  const names = parseSubLokasiFromApi(value);
  if (!names.length) return "-";
  // Hanya untuk tampilan; tidak diparse balik ke data
  return names.join(", ");
}

/** Payload simpan: selalu array nama (data baru). */
export function serializeSubLokasiForApi(subLokasi) {
  return JSON.stringify(normalizeSubLokasiToNames(subLokasi));
}
